<div class="no-internet-container">
    <h1>No Internet Connection</h1>
    <img src="assets/no-internet.png" class="no-internet-image" />
    <p>Please check your internet connection and try again.</p>
  </div>